import api from '../api'
import moment from 'moment'
//https://docs.google.com/document/d/1BJZvOnN389jEm7kFZ5bI3ruRBTXP26LuW-zZaAk60gE/edit#heading=h.fepgadymnwho

const MAX_ROUND_TRIP_TIME = 2000// 2 seconds
const RETRY_INTERVAL = 10000 // 5 seconds

export function syncClock() {
	const sentTime=moment()
	return (dispatch) => api.fetch('/current-time/')
		.then((response) => {
			const receivedTime=moment()
			const roundTripTime= receivedTime.diff(sentTime)
			const serverTime=moment(response.currentTime)
			const clockOffset=(serverTime.add(roundTripTime/2)).diff(receivedTime)
			if(roundTripTime<MAX_ROUND_TRIP_TIME ){
				dispatch({ type: 'CLOCK_SYNC_SUCCESS', clockOffset })
				if(window.analytics){
					window.analytics.track('Sync Clock', {
				  		offsetInMilliseconds:clockOffset
					})}
			}else{
				setTimeout(function() { //Start the timer
					dispatch(syncClock())
				},	RETRY_INTERVAL)
			}
		})	   
}


